import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { MapGrid } from '@/components/MapGrid';
import { Pagination } from '@/components/Pagination';
import { api } from '@/lib/api';

const MAPS_PER_PAGE = 24;

export function BrowseMapsPage() {
  const [currentPage, setCurrentPage] = useState(1);

  const {
    data: maps,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['maps', (currentPage - 1) * MAPS_PER_PAGE, MAPS_PER_PAGE],
    queryFn: ({ signal }) =>
      api.getMaps((currentPage - 1) * MAPS_PER_PAGE, MAPS_PER_PAGE, { signal }),
  });

  const {
    data: stats,
    isError: isStatsError,
    error: statsError,
  } = useQuery({
    queryKey: ['stats'],
    queryFn: ({ signal }) => api.getStats({ signal }),
  });

  const totalPages = stats ? Math.ceil(stats.total_maps / MAPS_PER_PAGE) : 1;
  const statsCopy = (() => {
    if (stats) {
      return `${stats.total_maps.toLocaleString()} maps available`;
    }
    if (isStatsError) {
      return statsError instanceof Error
        ? `Failed to load stats: ${statsError.message}`
        : 'Failed to load stats.';
    }
    return 'Loading...';
  })();

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-5xl font-display font-bold text-stone-100 tracking-wide">Browse All Maps</h1>
        <p className="text-stone-300 mt-2">{statsCopy}</p>
      </div>

      {isError && (
        <div className="rounded-md border border-blood-700 bg-blood-900/40 p-4 text-blood-300">
          {error instanceof Error ? error.message : 'Unable to load maps right now. Please try again later.'}
        </div>
      )}

      {!isError && <MapGrid maps={maps || []} isLoading={isLoading} />}

      {!isError && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
}
